import type {
    EagerJobInfo,
    LazyJobInfo,
    ShouldNotDisplayCard,
    JobFullData,
    JobsTbdCondition,
} from '@fiverr-private/jtbd_sdk';
import type { JobsTBDTypes } from '@fiverr-private/homepage_common_types';
import type { jtbdDismissInfo } from '@fiverr-private/jtbd_sdk/src/types/shared';

interface IdentifiedJob {
    jobType: JobsTBDTypes;
    condition?: JobsTbdCondition;
}
export interface IdentifiedEagerJobInfo extends IdentifiedJob {
    jobInfo: Exclude<EagerJobInfo, ShouldNotDisplayCard>;
}

export interface IdentifiedLazyJobInfo extends IdentifiedJob {
    jobInfo: Exclude<LazyJobInfo, ShouldNotDisplayCard>;
}

interface IdentifiedDismissibleJobInfo extends IdentifiedLazyJobInfo {
    jobDismissInfo: jtbdDismissInfo;
}

export type IdentifiedJobInfo = IdentifiedLazyJobInfo | IdentifiedEagerJobInfo;

export interface IdentifiedJobFullData extends IdentifiedJob {
    jobData: JobFullData;
}

export const isJobWithFullData = (job: IdentifiedJobInfo | IdentifiedJobFullData): job is IdentifiedJobFullData =>
    'jobData' in job;

export const isJobWithDismissInfo = (job: IdentifiedJobInfo): job is IdentifiedDismissibleJobInfo =>
    'jobDismissInfo' in job;
